import BankVoucherFormPage from "./BankVoucherFormPage";

export default function PaymentVoucherPage() {
  return <BankVoucherFormPage voucherType="PAYMENT" title="Payment Voucher" subtitle="Pay a vendor, expense or other payable from Cash or a Bank Account." />;
}
